import React, { useEffect } from 'react'

import logo from '../../../assets/images/common/nefos-logo-new.png'
import '../../../assets/styles/notification.scss'
import { IoClose } from 'react-icons/io5';

const PushNotification = ({ title, body, onClose }) => {
    useEffect(() => {

        const timer = setTimeout(() => {
            onClose();
        }, 9000);

        return () => clearTimeout(timer);
    }, [onClose]);
    return (
        <section className='pushnotifca'>
            <div className='notify'>
                <img src={logo} alt="icon" style={{ width: "86px", }} />
                <div className="notify-content">
                    <h4 className="notify-title">{title}</h4>
                    <p className="notify-body">{body}</p>
                </div>
                <button className="notify-close" onClick={onClose}>
                    <IoClose />
                </button>
            </div>
        </section>
    )
}

export default PushNotification
